/**
 * Trigger: tr_exchanges_soft_delete
 * Purpose: Update account balances when an exchange is soft deleted or restored
 * Table: exchanges
 * Event: UPDATE OF is_deleted
 */
export const TR_EXCHANGES_SOFT_DELETE = `
CREATE TRIGGER tr_exchanges_soft_delete
UPDATE OF is_deleted ON exchanges
WHEN new.is_deleted <> old.is_deleted
BEGIN
  UPDATE account_balances
  SET exchanges_amount = CASE
    WHEN new.is_deleted = 0 THEN exchanges_amount - old.amount_out
    ELSE exchanges_amount + old.amount_out
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_out_id;

  UPDATE account_daily_balances
  SET exchanges_amount = CASE
    WHEN new.is_deleted = 0 THEN exchanges_amount - old.amount_out
    ELSE exchanges_amount + old.amount_out
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_out_id
    AND balance_date = old.exchange_date;

  UPDATE account_balances
  SET exchanges_amount = CASE
    WHEN new.is_deleted = 0 THEN exchanges_amount + old.amount_in
    ELSE exchanges_amount - old.amount_in
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_in_id;

  UPDATE account_daily_balances
  SET exchanges_amount = CASE
    WHEN new.is_deleted = 0 THEN exchanges_amount + old.amount_in
    ELSE exchanges_amount - old.amount_in
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_in_id
    AND balance_date = old.exchange_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND balance_date = old.exchange_date
    AND currency_id IN (old.currency_out_id, old.currency_in_id)
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND activity_date = old.exchange_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_daily_balances.account_id = old.account_id
        AND account_daily_balances.balance_date = old.exchange_date
      LIMIT 1
    );
END;
`;
